import styled from '@emotion/styled';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const CloseWrapper = styled.div`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.mobileCloseButton};
  bottom: 16px;
  left: 50%;
  transform: translate(-50%, 0);
`;
